<template>
    <div class="pop_ups">
        <el-tabs  type="border-card" @tab-click="getEvent" :activeName='activeName'>
            <div class="form_head">
                <div class="detail">{{detail}}</div>
                <button @click="exit" class="formButton exit">退出</button>
            </div>
        
            <el-tab-pane  v-for="(value, key ) in menuNames " :key="key" :label="value" >
            </el-tab-pane>
            <router-view class="tab_pane" style="height:100%;width: 100%;"></router-view>

        </el-tabs>
       
    </div>

</template>

<script>
import css from '@/css/pop_ups.css'
import API from '@/api/login'
export default {
    name:'pop_ups',
    props:['menuTags','cunrrentMenu','menuNames','menuDetail'],
    data(){
        return{
            detail:'详细名称',
            activeName:'0'
        }
    },
    methods:{
        getEvent(event){
            if(event.index == this.$store.state.cunrrentPath) return;
            this.$store.state.cunrrentPath = event.index;
            this.$router.push(`/home/${this.cunrrentMenu}/${this.menuTags[event.index]}`);
            this.detail  = this.menuDetail[event.index];
        },
        exit(){
            this.$emit('exit')
        }
    },
    computed:{
    },
    watch:{
    },
    mounted(){
        this.detail  = this.menuDetail[0];
        this.activeName = '0'
    }
}
</script>

<style scoped>
.tab_pane{
    height: 100%;
    width: 100%;
}
</style>